import { createSelector } from 'reselect'

export default createSelector(
	[state => state.matchingPairsCt.entityUID],
	entityUid => entityUid
)
